import { Skeleton } from '@v2/ui';

export function HotelsListPlaceholder() {
  return (
    <div className="space-y-4">
      {[0, 1, 2, 3, 4, 5].map((item) => (
        <div
          className="w-full rounded-lg border border-gray-200 bg-white p-4 md:p-6"
          key={item.toString()}
        >
          <div className="flex flex-col items-stretch gap-4 xl:flex-row">
            <Skeleton className="aspect-video w-full shrink-0 rounded-lg xl:w-[32%]" />
            <div className="flex min-w-0 flex-1 flex-col items-start justify-start">
              <Skeleton className="mb-4 h-5 w-3/4" />
              <Skeleton className="h-5 w-1/2" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
